
import { type BaseSettings, createSettingsProvider } from "@qamf/settings-provider";

import type settingsSample from "../../settings/production-stable.json";
type Settings = BaseSettings & typeof settingsSample;
const { useSettingsManager, useSettings } = createSettingsProvider<Settings>();

function isDevelopSession() {
	const launchMode = useSettings().launchMode.value;

	return (
		launchMode === "DevelopSession"
	);
}

// Testing slots are Standard builds: their settings carry no launchMode, only the environment name.
function isDevSettingsEnabled() {
	return isDevelopSession() || useSettings().environment.value?.startsWith("testing-slot");
}

export {
	isDevelopSession,
	isDevSettingsEnabled,
	useSettings,
	useSettingsManager
};
